import React from 'react';

import styles from './BubbleButton.module.scss';

export interface ArButtonProps {
  label: string;
  onClick: () => void;
}

const BubbleButton: React.FC<ArButtonProps> = (props) => {
  return (
    <div data-testid='bubble-button' className={styles.ff_bubble} onClick={() => props.onClick()}>
      <div className={styles.ff_bubble__button}>{props.children}</div>
      <div className={styles.ff_bubble__text}>{props.label}</div>
    </div>
  );
};

export default BubbleButton;
